/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  GetBusinessOwnEnabledStatus,
  GetPromoTokensResponse,
  GetPromoTokensSort,
  PromoToken,
  PromoTokenBody,
  PromoTokenOpenLinkResponse,
  PromoTokenRedemptionCallbackBody,
  PromoTokenType,
  SortOrder,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetBusinessOwnEnabledStatusFromJSON,
    GetBusinessOwnEnabledStatusToJSON,
    GetPromoTokensResponseFromJSON,
    GetPromoTokensResponseToJSON,
    GetPromoTokensSortFromJSON,
    GetPromoTokensSortToJSON,
    PromoTokenFromJSON,
    PromoTokenToJSON,
    PromoTokenBodyFromJSON,
    PromoTokenBodyToJSON,
    PromoTokenOpenLinkResponseFromJSON,
    PromoTokenOpenLinkResponseToJSON,
    PromoTokenRedemptionCallbackBodyFromJSON,
    PromoTokenRedemptionCallbackBodyToJSON,
    PromoTokenTypeFromJSON,
    PromoTokenTypeToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/index';

export interface CreatePromoTokensRequest {
    promoTokenBody?: PromoTokenBody;
}

export interface CreatePromoTokensIdOpenLinkRequest {
    id: string;
}

export interface CreatePromoTokensRedemptionCallbackRequest {
    promoTokenRedemptionCallbackBody?: PromoTokenRedemptionCallbackBody;
}

export interface GetGoTokenRequest {
    token: string;
}

export interface GetPromoTokensRequest {
    type?: Array<PromoTokenType>;
    search?: string;
    sort?: GetPromoTokensSort;
    isEnabled?: GetBusinessOwnEnabledStatus;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetPromoTokensIdRequest {
    id: string;
}

export interface UpdatePromoTokensIdRequest {
    id: string;
    promoTokenBody?: PromoTokenBody;
}

/**
 * PromoTokensApi - interface
 * 
 * @export
 * @interface PromoTokensApiInterface
 */
export interface PromoTokensApiInterface {
    /**
     * Used by admins to create new promo token.
     * @param {PromoTokenBody} [promoTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    createPromoTokensRaw(requestParameters: CreatePromoTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to create new promo token.
     */
    createPromoTokens(requestParameters: CreatePromoTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Exchange a distributed reward ID for a short-lived signed redirect path. The returned path can be opened in a new tab without sending auth headers.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    createPromoTokensIdOpenLinkRaw(requestParameters: CreatePromoTokensIdOpenLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromoTokenOpenLinkResponse>>;

    /**
     * Exchange a distributed reward ID for a short-lived signed redirect path. The returned path can be opened in a new tab without sending auth headers.
     */
    createPromoTokensIdOpenLink(requestParameters: CreatePromoTokensIdOpenLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromoTokenOpenLinkResponse>;

    /**
     * Inbound webhook called by partner when a promo code is redeemed. Marks the IssuedPromoToken as REDEEMED and distributes the configured redemption reward via handleRewardDistribution.
     * @param {PromoTokenRedemptionCallbackBody} [promoTokenRedemptionCallbackBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    createPromoTokensRedemptionCallbackRaw(requestParameters: CreatePromoTokensRedemptionCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Inbound webhook called by partner when a promo code is redeemed. Marks the IssuedPromoToken as REDEEMED and distributes the configured redemption reward via handleRewardDistribution.
     */
    createPromoTokensRedemptionCallback(requestParameters: CreatePromoTokensRedemptionCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Validate a short-lived signed token and redirect to the promo reward URL. No auth header required — the token IS the credential.
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    getGoTokenRaw(requestParameters: GetGoTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate a short-lived signed token and redirect to the promo reward URL. No auth header required — the token IS the credential.
     */
    getGoToken(requestParameters: GetGoTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to get a list of all promo tokens
     * @param {Array<PromoTokenType>} [type] 
     * @param {string} [search] 
     * @param {GetPromoTokensSort} [sort] 
     * @param {GetBusinessOwnEnabledStatus} [isEnabled] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    getPromoTokensRaw(requestParameters: GetPromoTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromoTokensResponse>>;

    /**
     * Used to get a list of all promo tokens
     */
    getPromoTokens(requestParameters: GetPromoTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromoTokensResponse>;

    /**
     * Used to get a single promo token.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    getPromoTokensIdRaw(requestParameters: GetPromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromoToken>>;

    /**
     * Used to get a single promo token.
     */
    getPromoTokensId(requestParameters: GetPromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromoToken>;

    /**
     * Used by admins to update existing promo token.
     * @param {string} id 
     * @param {PromoTokenBody} [promoTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    updatePromoTokensIdRaw(requestParameters: UpdatePromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to update existing promo token.
     */
    updatePromoTokensId(requestParameters: UpdatePromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PromoTokensApi extends runtime.BaseAPI implements PromoTokensApiInterface {

    /**
     * Used by admins to create new promo token.
     */
    async createPromoTokensRaw(requestParameters: CreatePromoTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/promo-tokens`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromoTokenBodyToJSON(requestParameters['promoTokenBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to create new promo token.
     */
    async createPromoTokens(requestParameters: CreatePromoTokensRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPromoTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Exchange a distributed reward ID for a short-lived signed redirect path. The returned path can be opened in a new tab without sending auth headers.
     */
    async createPromoTokensIdOpenLinkRaw(requestParameters: CreatePromoTokensIdOpenLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromoTokenOpenLinkResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createPromoTokensIdOpenLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/promo-tokens/{id}/open-link`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromoTokenOpenLinkResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a distributed reward ID for a short-lived signed redirect path. The returned path can be opened in a new tab without sending auth headers.
     */
    async createPromoTokensIdOpenLink(requestParameters: CreatePromoTokensIdOpenLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromoTokenOpenLinkResponse> {
        const response = await this.createPromoTokensIdOpenLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Inbound webhook called by partner when a promo code is redeemed. Marks the IssuedPromoToken as REDEEMED and distributes the configured redemption reward via handleRewardDistribution.
     */
    async createPromoTokensRedemptionCallbackRaw(requestParameters: CreatePromoTokensRedemptionCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/promo-tokens/redemption-callback`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromoTokenRedemptionCallbackBodyToJSON(requestParameters['promoTokenRedemptionCallbackBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Inbound webhook called by partner when a promo code is redeemed. Marks the IssuedPromoToken as REDEEMED and distributes the configured redemption reward via handleRewardDistribution.
     */
    async createPromoTokensRedemptionCallback(requestParameters: CreatePromoTokensRedemptionCallbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPromoTokensRedemptionCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * Validate a short-lived signed token and redirect to the promo reward URL. No auth header required — the token IS the credential.
     */
    async getGoTokenRaw(requestParameters: GetGoTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getGoToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/go/{token}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate a short-lived signed token and redirect to the promo reward URL. No auth header required — the token IS the credential.
     */
    async getGoToken(requestParameters: GetGoTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getGoTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Used to get a list of all promo tokens
     */
    async getPromoTokensRaw(requestParameters: GetPromoTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromoTokensResponse>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['isEnabled'] != null) {
            queryParameters['isEnabled'] = requestParameters['isEnabled'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/promo-tokens`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromoTokensResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all promo tokens
     */
    async getPromoTokens(requestParameters: GetPromoTokensRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromoTokensResponse> {
        const response = await this.getPromoTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a single promo token.
     */
    async getPromoTokensIdRaw(requestParameters: GetPromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromoToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPromoTokensId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/promo-tokens/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromoTokenFromJSON(jsonValue));
    }

    /**
     * Used to get a single promo token.
     */
    async getPromoTokensId(requestParameters: GetPromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromoToken> {
        const response = await this.getPromoTokensIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to update existing promo token.
     */
    async updatePromoTokensIdRaw(requestParameters: UpdatePromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePromoTokensId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/promo-tokens/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PromoTokenBodyToJSON(requestParameters['promoTokenBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to update existing promo token.
     */
    async updatePromoTokensId(requestParameters: UpdatePromoTokensIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePromoTokensIdRaw(requestParameters, initOverrides);
    }

}
